module.exports = __webpack_public_path__ + "static/fipcbluepandamain-2c857ca34327263320a1dcaf7bd0aa86.jpeg";